import WidgetModal from 'conversations-visitor-message-history/widget-modal/WidgetModal';
import { WidgetModalProvider, useWidgetModalOrContext } from 'conversations-visitor-message-history/widget-modal/WidgetModalContext';
import styled from 'styled-components';
import { WHITE } from 'visitor-ui-component-library/constants/WidgetColors';
import { useBrowserWindowContext } from '../../components/BrowserWindowContext';
import { getSideDockWidth } from '../constants/sideDockConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SideDockOuterWrapper = styled.div.withConfig({
  displayName: "SideDockStyleWrapper__SideDockOuterWrapper"
})(["display:flex;flex-direction:column;height:100%;width:100%;"]);
const SideDockContentWrapper = styled.div.withConfig({
  displayName: "SideDockStyleWrapper__SideDockContentWrapper"
})(["height:100%;display:flex;flex-direction:column;background:", ";overflow:hidden;position:relative;width:", "px;"], WHITE, ({
  $width
}) => $width);
const SideDockStyleWrapperContent = ({
  children
}) => {
  const {
    isOpen,
    closeModal,
    modalContent
  } = useWidgetModalOrContext();
  const {
    browserWindowWidth
  } = useBrowserWindowContext();
  const sideDockWidth = getSideDockWidth(browserWindowWidth);
  return /*#__PURE__*/_jsx(SideDockOuterWrapper, {
    "data-test-id": "side-dock-style-wrapper",
    children: /*#__PURE__*/_jsxs(SideDockContentWrapper, {
      className: "side-dock-widget",
      "data-test-id": "side-dock-content-wrapper",
      $width: sideDockWidth,
      children: [children, /*#__PURE__*/_jsx(WidgetModal, {
        isOpen: isOpen,
        onClose: closeModal,
        modalContent: modalContent
      })]
    })
  });
};
SideDockStyleWrapperContent.displayName = 'SideDockStyleWrapperContent';
const SideDockStyleWrapper = ({
  children
}) => {
  return /*#__PURE__*/_jsx(WidgetModalProvider, {
    children: /*#__PURE__*/_jsx(SideDockStyleWrapperContent, {
      children: children
    })
  });
};
SideDockStyleWrapper.displayName = 'SideDockStyleWrapper';
export default SideDockStyleWrapper;